export default {
  app: {
    orgCode: "Número de grupo/marca",
    orgCodePlaceholder: "Introduzca núm. de grupo/marca",
    username: "cuenta",
    usernamePlaceholder: "Por favor ingrese su número de cuenta",
    password: "contraseña",
    passwordPlaceholder: "Por favor, introduzca su contraseña",
    captcha: "Código de verificación",
    captchaPlaceholder: "Introduzca código de verificación",
    captchaExpired: "Actualice el código de verificación.",
    login: "Acceso",
    remember: "Acuérdate de mí",
    switchPC: "Cambiar al fondo",
    mobileVersion: "BI Móvil",
    desktopVersion: "Backend del Comerciante",
    setupPassword: "Establecer contraseña",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Por favor ingrese una nueva contraseña",
    retypePassword: "Vuelva a ingresar la nueva contraseña",
    retypePasswordPlaceholder: "Por favor ingrese su nueva contraseña nuevamente",
    setupPasswordRule: "La contraseña debe tener entre 6 y 32 caracteres y debe contener dos o más combinaciones de números, letras y símbolos.",
    setupPasswordRuleRefer: "La contraseña debe tener entre 6 y 32 caracteres y debe contener dos o más combinaciones de números, letras y símbolos. Por favor, vuelva a entrar.",
    setupPasswordOk: "Seguro",
    setupPasswordDiffer: "Las contraseñas ingresadas dos veces no coinciden. Por favor, vuelva a introducir la contraseña.",
    err_def: "Error al iniciar sesión, actualice la página e inténtelo nuevamente.",
    err_2000: "El código de verificación fue ingresado incorrectamente.",
    err_2010: "La información de inicio de sesión se ingresó incorrectamente.",
    err_4001: "Esta cuenta no ha autorizado ninguna función.",
    err_4011: "La tienda está deshabilitada y no se puede iniciar sesión.",
    err_4012: "El franquiciado ha sido desactivado y no puede iniciar sesión.",
    err_4013: "La marca está deshabilitada, no se puede iniciar sesión.",
    err_4014: "El grupo está deshabilitado y no se puede iniciar sesión.",
    err_4015: "La zona está deshabilitada, no se puede iniciar sesión.",
    err_4401: "Esta cuenta no está autorizada para esta tienda.",
    err_4402: "Esta cuenta no tiene privilegios de administrador y no puede obtener un código de verificación.",
    err_5001: "Error al establecer la contraseña, por favor inténtelo nuevamente.",
  },
  verifyRefund: {
    title: "Solicitud de devolución",
    hint: "¡Confirme que la información de devolución sea correcta antes de proporcionar el código de verificación!",
    verifyCode: "Código de verificación",
    copy: "Copiar",
    copySucceed: "Copia exitosa",
    copyFailed: "Error de copia",
    expireTime: "Tiempo de expiración",
    shop: "Tienda",
    soTime: "Hora del pedido",
    soNo: "Número de pedido POS",
    amount: "Monto del reembolso",
  },
}